import { render, staticRenderFns } from "./redeemcode.vue?vue&type=template&id=7ef50afb&scoped=true"
import script from "./redeemcode.vue?vue&type=script&lang=js"
export * from "./redeemcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef50afb",
  null
  
)

export default component.exports